import denormalize from 'denormalize'
import pluralize from 'pluralize'
import { actions as formActions } from 'react-redux-form'

// Forms edit entities in the store directly, so leaving a form without saving would leave the
// unsaved edits behind. A form takes a snapshot of the records it edits (the entity plus the
// nested records upsertEntity would send along) and restores it when it closes without saving.

// Returns { entityName: { id: record } }, or null when the entity is not (yet) in the store.
const collectRecords = (entities, entityName, entityId, relationships) => {
  let denormalized
  try {
    denormalized = denormalize(entities, entityName, entityId, relationships)
  } catch (e) {
    return null
  }
  if (!denormalized || !denormalized.data) return null

  const records = {}
  const included = [denormalized.data, ...denormalized.included]
  included.forEach(({ type, id }) => {
    const name = pluralize.singular(type)
    const record = entities[name]?.byId?.[id]
    if (record) {
      records[name] = records[name] || {}
      records[name][id] = record
    }
  })
  return records
}

export function takeFormSnapshot(entityName, entityId, relationships = []) {
  return function(dispatch, getState) {
    return collectRecords(getState().entities, entityName, entityId, relationships)
  }
}

// Records created while editing (e.g. an address added via the form) are left in the store;
// restoring their parent unlinks them, so they are never saved. Records that have since been
// removed from the store (e.g. destroyed) are not brought back.
export function restoreFormSnapshot(snapshot) {
  return function(dispatch, getState) {
    const entities = getState().entities
    Object.keys(snapshot).forEach((name) => {
      Object.keys(snapshot[name]).forEach((id) => {
        const current = entities[name]?.byId?.[id]
        if (current && current !== snapshot[name][id]) {
          dispatch(formActions.change(`entities.${name}.byId.${id}`, snapshot[name][id]))
        }
      })
    })
  }
}
